<template>
  <v-container fluid pa-0 mt-0 fill-height>
    <v-layout wrap row justify-content-center>
      <rHeader
        v-if="globals"
        :title_first_line="$t(globals.header)"
        :title_second_line="$t(globals.header2)"
        :herb_image="globals.herb"
        :header_image="globals.topimage"
      ></rHeader>
      <v-flex xl10 md10 sm12 xs12>
        <router-link to="/">
          <v-btn block color="info">{{ $t('back_to_homepage') }}</v-btn>
        </router-link>

        <v-card>
          <v-card-title>
            <span v-html="$t(globals.cancelallheader)"></span>
          </v-card-title>
        </v-card>

        <v-card class="my-2">
          <v-card-title class="font-weight-bold red--text text-center display-1" v-if="showSummary && !hasError">
            {{ $t(globals.cancelallsuccess) }}
          </v-card-title>
          <v-card-title class="font-weight-bold red--text text-center display-1" v-if="hasError">
            <span v-if="!msgExt">{{ $t(globals.cancelallerror) }}</span>
            <hr>
            <span v-if="msgExt"> {{ msgExt }}</span>
          </v-card-title>
          <v-card-title v-if="!showSummary">
            <!-- START FORM CONTAINER -->
            <v-flex>
              <!-- START FORM -->
              <v-form v-model="form_valid" ref="form" lazy-validation>
                <!-- START FORM LAYOUT-->
                <v-layout column>
                  <v-flex>
                    <v-layout row>
                      <!-- START FORM INPUT FIELDS -->
                      <v-flex p-0 m-0>
                        <v-flex class="text-center">
                          <h3 class="display-2">{{ $t('fill_form') }}</h3>
                        </v-flex>
                        <v-flex
                          xs12
                          md12
                          py-0
                          my-0
                          v-for="form_field in form_fields"
                          :key="form_field.id"
                        >
                          <v-text-field
                            v-if="['tekst','email'].includes(form_field.type)"
                            v-model="form_values[form_field.sedco_key]"
                            :label="stripHtml($t(form_field.display_name))"
                            :rules="[v => !!v || $t('field_required'),
                            v => new RegExp(form_field.validator).test(v) || $t('input_correct_field') + stripHtml($t(form_field.display_name)).toLowerCase()]"
                            required
                            box
                          ></v-text-field>
                          <v-layout
                            column
                            wrap
                            p-0
                            m-0
                            v-if="['captcha'].includes(form_field.type) && captcha"
                          >
                            <v-flex p-3 m-0 v-html="captcha.CAPTCHA" captcha text-center></v-flex>
                            <v-flex
                              text-center
                              p-0
                              m-0
                              v-if="captcha.READ && speech.hasBrowserSupport()"
                            >
                              {{ $t('read_captcha') }}
                              <a
                                class="text-small text-primary"
                                @click="readCaptcha"
                              >{{ $t('click_here') }}</a>
                            </v-flex>
                            <v-flex text-center>{{ $t('big_letters_only') }}</v-flex>
                            <v-flex p-0 m-0>
                              <v-text-field
                                required
                                box
                                :label="stripHtml($t(form_field.display_name))"
                                :rules="[
                              v => !!v || $t('field_required'), v => captcha.HASH == hash(v) || $t('input_correct_field')
                            ]"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- END FORM INPUT FIELDS -->
                  <!-- START FORM SUBMIT BUTTON -->
                  <v-flex>
                    <v-btn
                      block
                      color="secondary"
                      :disabled="!form_valid"
                      @click="submit"
                    >{{ $t('withdrawconsent') }}</v-btn>
                  </v-flex>
                  <!-- END FORM SUBMIT BUTTON -->
                </v-layout>
                <!-- END FORM LAYOUT-->
              </v-form>
              <!-- END FORM -->
            </v-flex>
            <!-- END FORM CONTAINER -->
          </v-card-title>
        </v-card>

        <v-card>
          <v-card-title>
            <span v-html="$t(globals.cancelallfooter)"></span>
          </v-card-title>
        </v-card>
      </v-flex>
      <rFooter class="mt-2" :footer_left="$t(globals.footer_left)" :footer_right="$t(globals.footer_right)"></rFooter>
    </v-layout>
  </v-container>
</template>

<script>
import RemoteData from "../mixins/remotedata";
import Utilities from "../mixins/utilities";
import Speech from "speak-tts";
import axios from "axios";

export default {
  name: "CancelAllPage",
  data: function() {
    return {
      form_valid: false,
      form_values: {},
      speech: new Speech(),
      showSummary: false,
      hasError: false,
      msgExt: false
    };
  },
  props: ["globals"],
  mixins: [
    Utilities,
    RemoteData({
      captcha: env.apiLinks.captcha
    }),
    RemoteData({
      form_fields: env.apiLinks.formfields
    })
  ],
  methods: {
    readCaptcha: function(event) {
      this.speech.speak({
        text: this.captcha.READ.split("").join(".")
      });
    },
    hash: function(value) {
      if (value) {
        var hash = 5381;
        for (var i = 0; i < value.length; i++) {
          hash = (hash << 5) + hash + value.charCodeAt(i);
        }
        return hash;
      }
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        const formData = {
          FormValues: this.form_values,
          SelectedLanguage: this.$i18n.locale,
        };

        var bodyFormData = new FormData();
        bodyFormData.set("JSONForm", JSON.stringify(formData));
        this.$store.state.message = "cancelall_progress";
        this.$store.state.loading = true;
        axios({
          method: "post",
          url: env.serwerURL + env.apiLinks.cancelall,
          data: bodyFormData,
          config: { headers: { "Content-Type": "multipart/form-data" } }
        })
        .then((response) => {
          this.$store.state.loading = false;
          if(response.data.UPDATED == 0){
            this.hasError = true;
            this.msgExt = this.$t('cancelallnotfound');
          }else if(response.data.UPDATED == -1){
            this.hasError = true;
            this.msgExt = this.$t('wrong_email_settings');
          }else{
            this.hasError = false;
            this.msgExt = null;
            this.showSummary = true;
          }
        })
        .catch((error) => {
          this.$store.state.loading = false;
          this.hasError = true;
          this.msgExt = error;
        });
      }
    }
  },
  created: function() {
    this.speech.init({ volume: 1, rate: 1, splitSentences: true });
    this.speech.speak({
      text: ""
    });
  }
};
</script>

<style scoped>
  .captcha {
    font-family: "Courier New", monospace !important;
    font-size: 6px;
    font-weight: bold;
    letter-spacing: -1px;
    line-height: 3px;
  }

.v-btn {
  height: auto;
  flex-flow: row wrap;
  padding: 0.5rem;
}

.v-btn /deep/ p {
  width: 100%;
  margin-bottom: 0.1rem;
}

.v-btn /deep/ span {
  width: 100%;
}

.v-btn{
  height: auto;
}

.v-btn /deep/ .v-btn__content{
  white-space: pre-line !important;
}

.v-btn:hover {
  text-decoration: none;
}
</style>